import { useDispatch, useSelector } from "react-redux"
import { changeSearchTarget, changeSearchTerm, createFilter, selectFilters, selectSearchMode, selectSearchTarget, selectSearchTargetOptions, selectSearchTerm } from "./searchBarSlice";

import './SearchBar.css';

export default function SearchBar() {
    const dispatch = useDispatch();

    const searchMode = useSelector(selectSearchMode);
    const searchTerm = useSelector(selectSearchTerm);
    const searchTarget = useSelector(selectSearchTarget);
    const searchTargetOptions = useSelector(selectSearchTargetOptions);
    const filters = useSelector(selectFilters);

    const handleSearchTermChange = (event) => {
        const newSearchTerm = event.target.value;
        dispatch(changeSearchTerm(newSearchTerm));
    }

    const handleSearchTargetChange = (event) => {
        const newSearchTarget = event.target.value;
        dispatch(changeSearchTarget(newSearchTarget));
    }

    const handleSearchButtonClick = (event) => {
        event.preventDefault();

        const newFilter = {
            id: filters.length + 1,
            searchMode: searchMode,
            searchTerm: searchTerm,
            searchTarget: searchTarget,
            active: true
        }

        dispatch(createFilter(newFilter));
        dispatch(changeSearchTerm(''));
    }

    return (
        <div className="searchBar">
            <h3>Search by </h3>
            <label htmlFor="searchTarget">
                <select value={searchTarget} onChange={handleSearchTargetChange}>\
                    {searchTargetOptions.map(option => {
                        return <option value={option}>{option}</option>
                    })}
                </select>
            </label>
            
            <label htmlFor="searchTerm">
                <input type="text" onChange={handleSearchTermChange} value={searchTerm}></input>
            </label>
            <button onClick={handleSearchButtonClick}>Search</button>
        </div>
    )
}